<script>
import Legal from "./Legal";
import Representative from "./Representative";
import RepresentativeAddress from "./Address";

import { mapState } from "vuex";

const STEP_COMPONENTS = ["representative", "representative-address", "legal"];

export default {
  components: {
    Legal,
    Representative,
    RepresentativeAddress
  },

  computed: {
    ...mapState("signUp", ["legal_step"]),
    stepComponent() {
      return STEP_COMPONENTS[this.legal_step];
    }
  }
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <component class="content" :is="stepComponent" />
  </transition>
</template>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Accountable/Types/Legal/Index.vue